/**
 * TODO: create a generic component of Heading and repass the data as a prop
 * example:
 * <!-- usability --!>
 * <Layout headingProps={{ ...props }} />
 *
 * <!-- implementation (inside of this component) --!>
 * <div>
 *  <Heading {...props} />
 * </div>
 */
import PropTypes from 'prop-types';
import { cloneElement } from 'react';

import Grid from 'shopper/components/Grid';
import Cell from 'shopper/components/Grid/Cell';

import Footer from 'components/Footer';
import FooterWithHydrationOnDemand from 'components/Footer/WithHydrationOnDemand';
import ScrollToTopButton from 'components/ScrollToTopButton';

import LayoutMargin from './Margin';

const Layout = ({
  children,
  gaEventCategory,
  gridProps,
  headingComponent,
  sidebarComponent,
  footerProps,
  maxWidthOnMobileDevices,
  scrollToTopButton,
  withGridLayout,
  ...rest
}) => (
  <>
    <LayoutMargin maxWidthOnMobileDevices={maxWidthOnMobileDevices} {...rest}>
      {headingComponent &&
        cloneElement(headingComponent, {
          mx: maxWidthOnMobileDevices ? [4, null, null, 0] : null,
        })}
      {withGridLayout ? (
        <Grid as="main" gridGap={0} {...gridProps}>
          <Cell
            as="section"
            flexWrap="nowrap"
            gridColumnEnd={['span 4', null, 'span 12']}
          >
            {children}
          </Cell>
          {sidebarComponent}
        </Grid>
      ) : (
        <>{children}</>
      )}
      {scrollToTopButton && (
        <ScrollToTopButton gaEventCategory={gaEventCategory} mb={11} />
      )}
    </LayoutMargin>
    {footerProps.hydrationOnDemand ? (
      <FooterWithHydrationOnDemand {...footerProps} />
    ) : (
      <Footer {...footerProps} />
    )}
  </>
);

Layout.defaultProps = {
  footerProps: {},
  gaEventCategory: null,
  headingComponent: null,
  maxWidthOnMobileDevices: false,
  scrollToTopButton: false,
  sidebarComponent: null,
  withGridLayout: true,
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  footerProps: PropTypes.shape(),
  gaEventCategory: PropTypes.string,
  gridProps: PropTypes.shape(),
  headingComponent: PropTypes.shape(),
  maxWidthOnMobileDevices: PropTypes.bool,
  scrollToTopButton: PropTypes.bool,
  sidebarComponent: PropTypes.node,
  withGridLayout: PropTypes.bool,
};

export default Layout;
